// extracted by mini-css-extract-plugin
export var arrow = "carouselLarge-module--arrow--9166b";
export var buttons = "carouselLarge-module--buttons--0e57a";
export var carousel = "carouselLarge-module--carousel--2461d";
export var carouselWrapper = "carouselLarge-module--carouselWrapper--4342d";
export var container = "carouselLarge-module--container--b0edb";
export var controls = "carouselLarge-module--controls--89b2c";
export var eyebrow = "carouselLarge-module--eyebrow--73fc5";
export var gradientMask = "carouselLarge-module--gradientMask--e886f";
export var gradientWrap = "carouselLarge-module--gradientWrap--52baa";
export var headline = "carouselLarge-module--headline--5b890";
export var heroCta = "carouselLarge-module--heroCta--f83bf";
export var heroGradient = "carouselLarge-module--heroGradient--ab8b8";
export var homeArrow = "carouselLarge-module--homeArrow--40f8d";
export var homeCarousel = "carouselLarge-module--homeCarousel--1fb1d";
export var homeSubheading = "carouselLarge-module--homeSubheading--8ce7a";
export var homeText = "carouselLarge-module--homeText--66a3f";
export var landingContainer = "carouselLarge-module--landingContainer--cd97c";
export var landingWrapper = "carouselLarge-module--landingWrapper--e50a0";
export var mobileControls = "carouselLarge-module--mobileControls--be8ee";
export var playVideoLink = "carouselLarge-module--playVideoLink--e658f";
export var scaletimer = "carouselLarge-module--scaletimer--75151";
export var slide = "carouselLarge-module--slide--ac0bf";
export var slider = "carouselLarge-module--slider--c03f3";
export var subheading = "carouselLarge-module--subheading--9a259";
export var text = "carouselLarge-module--text--d9541";
export var waveBg = "carouselLarge-module--waveBg--80943";
export var waveInner = "carouselLarge-module--waveInner--52b82";